import React, { Component } from 'react'
import {auth} from './Firebase'
import {signInWithEmailAndPassword} from "firebase/auth";
import { useNavigate } from 'react-router-dom';

export default class Login extends Component {
  constructor(props){
    super(props);
    this.state={
      look:false,
      UserEmail:'',
      Password:''
    }
  }

//function for toggle the password visible icon
  onChangeLook =() => {
    this.setState({
      look: !this.state.look
    })
  }
  handleClick=(e)=>{
    e.preventDefault()
    signInWithEmailAndPassword(auth, this.state.UserEmail, this.state.Password)
        .then((userCredential) => {
            const user = userCredential.user;
            this.props.navigate('/Dashboard')
            console.log(user)
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(errorCode,errorMessage)
            if(errorMessage ==='Firebase: Error (auth/wrong-password).'){
                alert('Invalid Password')
            }
            if(errorMessage ==='Firebase: Error (auth/invalid-email).'){
                alert('Invalid Email')
            } 
        });
  }
  render() {
    const {look} =this.state;
    return (
      <div className='LS'>

        <div className='Login'>

          <div className='LLogo'>
            <img src='https://www.washmartindia.in/static/media/laundryLogo.87041ffc.svg' alt='logo' width='300px' height='90px'></img>
            <h1>Welcome back</h1>
            <span>Let’s start with the day, login to continue</span>
          </div>

          <div className='LForm'>
            <form className='LF'>
              <input type='text' placeholder='Email : (atharv@test.com)' onChange={(e)=>{
                            this.setState({
                                UserEmail:e.target.value
                            })}}></input>
              <div className='password'>
              <input type={look ? 'text': "password"} placeholder='Password : (Atharv@1234)'onChange={(e)=>{
                            this.setState({
                                Password:e.target.value
                            })}}></input>
              <img onClick={()=> this.onChangeLook()} src={look ? "https://www.washmartindia.in/static/media/Show.3ceb3719.svg" : "https://www.washmartindia.in/static/media/Hide.e875c53e.svg"} alt='visible' width='34px' height='34px'></img>
              </div>
              
            </form>
            <button type='submit' onClick={(e)=>this.handleClick(e)}>Login</button>
          </div>
          
        </div>
        
      </div>
    )
  }
}

export function LoginH (props){
  const navigate = useNavigate()
  return(<Login navigate={navigate}/>)
}